import app from '../../../scripts/app';

app.service('descriptionAndPhotosService', [
  'apiService',
  function (apiService) {
    /**
     * todo: вместо locationId надо передавать все значения locationPath через запятую
     * Минимальное кол-во фото для текущего пользователя и указанных региона и категории
     * @param category Категория объявления
     * @param locationId Ид региона или города в регионе
     */
    this.getMinPhotoCount = (category, locationPath) => {
      const config = { cache: true };

      return apiService.getMinPhotoCount(
        {
          category,
          locationPath,
        },
        config,
      );
    };
  },
]);
